module.exports = __webpack_public_path__ + "img/FacebookAds.d747dd2c.svg";